import { v4 as uuid } from 'uuid';

export const AUTH_LOGOUT_STORAGE_KEY = 'autoscript:auth:logout';

export function broadcastLogout(): void {
  try {
    window.localStorage.setItem(AUTH_LOGOUT_STORAGE_KEY, uuid());
  } catch {
    return;
  }
}

export function isLogoutStorageEvent(event: StorageEvent): boolean {
  return event.key === AUTH_LOGOUT_STORAGE_KEY;
}
